import React, { Component } from "react";

import {
  Modal,
  TextContainer,
  Scrollable,
  TextField,
  Banner,
  Popover,
  Icon,
} from "@shopify/polaris";
import { 
  ChevronDownMinor
} from "@shopify/polaris-icons";
import ApplyKeywordList from "../ApplyKeywordList";
import "./index.css";
import { store } from "../../../src/redux/store";
//翻译包
import Language from '../../i18n/Language';
import ToastFunc from "../ToastFunc";
const t = Language

class AddKeywordsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showToast: false,
      showToastText: '',
      showToastIserror: '',
      
      loadingPage: true,
      modalActive: false,
      sheetActive: false,

      title: "",
      description: "",

      //保存星级
      StarRating: 0,

      //关键词输入
      keyword: '',
      //链接输入
      link: '',
      keywordError: '',
      linkError: '',
      isShowApplyBox: false,
    };
  }

  shouldComponentUpdate(nextProps) {
    if(nextProps.open !== this.props.open) {
      if(!nextProps.open) {
        this.setState({
          isShowBanner: false,
          textTip: '',
          keyword: '',
          link: '',
          keywordError: '',
          linkError: '',
        })
      }
    }

    return true;
  }

  //关闭回调
  Closeback = () => {
    this.props.CloseDeletePop(!this.props.open)
    this.setState({
      keyword: '',
      link: ''
    })
  }

  // keyword改变
  handleKeywordChange = value => {
    if(value && value.length > 200) {
      this.setState({
        keyword: value.slice(0, 200),
        keywordError: 'The maximum length is 200',
      })
    } else {
      this.setState({
        keyword: value,
        keywordError: '',
      })
    }
  }

  // link改变
  handleLinkChange = value => {
    this.setState({
      link: value,
      linkError: '',
    })
  }

  // 保存
  handleSaveAction = async () => {
    // 这个changeData()就是激活父组件的方法，可以传值
    if(this.state.keyword === '' || this.state.link === '') {
      if(this.state.keyword === '') {
        this.setState({
          keywordError: "Please enter keywords",
        })
      }
      if(this.state.link === '') {
        this.setState({
          linkError: "Please enter your own link"
        })
      }
    } else {
      this.props.changeData(!this.props.open, this.state.keyword, this.state.link).then((res) => {
        if (res === 200) {
          this.setState({
            keyword: '',
            link: ''
          })
        }

        // 错误状态 展示提示banner
        if (Number(res.code) === 400) {
          this.setState({
            isShowBanner: true,
            textTip: res.msg
          })
        }
      })
    }
  }

  //点击联系客服
  handleContactService = () => {
    try {
      window.Willdesk.show()
    } catch(e) {
      this.toggleToast(t("Try again later"), true);
    }
  }
  
  //提示弹窗
  toggleToast = (showToastText, showToastIserror) => {
    this.setState({
      showToast: false
    }, () => {
      this.setState(({ showToast }) => ({
        showToast: !showToast,
        showToastText: showToastText,
        showToastIserror: showToastIserror
      }));
    });
  };

  // 关闭申请弹窗
  closeApplyBox = () => {
    this.setState({ isShowApplyBox: false })
  }

  // 选中数据
  changeSelectApply = (data) => {
    let compares = {
      "Products": "products",
      "Homepage": "",
      "Collections": "collections",
      "Blogs": "blogs",
      "Other Pages": "pages",
    }
    let linkNew = data[0] === "Homepage" ? `https://${store.getState().public.domain}` : 
      data[0] === "Blogs" ? `https://${store.getState().public.domain}/${compares[data[0]]}/${data[1].blog_handle}/${data[1].handle}` : `https://${store.getState().public.domain}/${compares[data[0]]}/${data[1].handle}`;
    this.setState({
      isShowApplyBox: false,
      link: linkNew,
    })
  }

  componentWillUnmount = async () => {
    this.setState = () => false
  }

  render() {
    const {
      state: { keyword, link, keywordError, linkError, textTip, isShowBanner, showToastText, showToast, showToastIserror, isShowApplyBox },
      props: { open, addKeywordsStatus },
      Closeback,
      handleKeywordChange,
      handleLinkChange,
      handleSaveAction,
    } = this;

    // 提示
    const toastMarkup = showToast ? <ToastFunc content={showToastText} onDismiss={showToast} error={showToastIserror} /> : null;

    const pageContent =
      <Modal
        size="small"
        open={open}
        onClose={Closeback}
        title={t("Add Keywords")}
        primaryAction={[
          {
            content: t("Save"),
            onAction: handleSaveAction,
            loading: addKeywordsStatus
          }
        ]}
      >
        <Modal.Section>
          {
            isShowBanner && <Banner
              title={textTip}
              tone="critical"
              onDismiss={() => {
                this.setState({ isShowBanner: false, })
              }}
              action={{
                content: t("Contact us"),
                onAction: this.handleContactService
              }}
            >
            </Banner>
          }
          <TextContainer>
            <Scrollable style={{ padding: "0.6rem", height: "100%", borderBottom: '0.1rem solid #eee', textAlign: 'center' }}>
              <TextField
                value={keyword}
                onChange={handleKeywordChange}
                label={t("Add a new keyword")}
                type="text"
                autoComplete="off"
                placeholder={t("keyword")}
                error={t(keywordError)}
              />
            </Scrollable>
          </TextContainer>
          <TextContainer>
            <Scrollable style={{ padding: "0.6rem", height: "100%" }}>
              <TextField
                value={link}
                onChange={handleLinkChange}
                label={t("Add the link corresponding")}
                type="text"
                autoComplete="off"
                suffix={<span 
                  className="chevronApply"
                  onClick={() => { this.setState({ isShowApplyBox: true }) }}
                >
                  <Icon source={ChevronDownMinor} />
                </span>}
                placeholder="https://example.com/products/test"
                error={t(linkError)}
              />
              <Popover
                active={isShowApplyBox}
                activator={<span className="fill_site"></span>}
                onClose={this.closeApplyBox}
              >
                <ApplyKeywordList 
                  mode="single"
                  changeSelectApply={this.changeSelectApply}
                />
              </Popover>
            </Scrollable>
          </TextContainer>
        </Modal.Section>
      </Modal>;

    return (
      <div className="footerRating">
        <div className="footerRating_child">
          {pageContent}
          {toastMarkup}
        </div>
      </div>
    );
  }
}

export default AddKeywordsModal;